import { EventContentArg } from '@fullcalendar/react';
import * as React from 'react';

export default (eventInfo: EventContentArg) => {
    const { event } = eventInfo;
    const { extendedProps, url } = event || {};
    const { categories, moreInfo, location, locationDetail, eventDetail, eventTitle } = extendedProps || {};

    return (
        <div className='row text-break'>
            {/* Left side */}
            <div className='col col-12 col-md-3 col-lg-2 mb-3 mb-md-0 order-1'>
                {categories ? (
                    <>
                        <div className='font-weight-bold'>Category</div>
                        <div className='mb-3'>{categories}</div>
                    </>
                ) : (
                    ''
                )}
                {moreInfo ? (
                    <>
                        <div className='font-weight-bold'>More info</div>
                        <a href={moreInfo} target="_blank">{moreInfo}</a>
                    </>
                ) : (
                    ''
                )}
            </div>
            {/* Center */}
            <div className='col col-12 col-md-6 col-lg-8 mb-3 mb-md-0 order-3 order-md-2'>
                <h5 className='heading'>
                    <a href={url} target='_blank'>{ eventTitle }</a>
                </h5>
                {eventDetail ? <div className='mb-3' dangerouslySetInnerHTML={{ __html: eventDetail }}></div> : ''}
                {locationDetail ? (
                    <>
                        <div className='font-weight-bold'>Location detail</div>
                        <div>{locationDetail}</div>
                    </>
                ) : (
                    ''
                )}
            </div>
            {/* Right side */}
            <div className='col col-12 col-md-3 col-lg-2 order-2 order-md-3'>
                {location ? (
                    <>
                        <div className='font-weight-bold'>Location</div>
                        <div className='mb-3'>{location}</div>
                    </>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};
